<template>
  <b-nav-item-dropdown
    :lazy="true"
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    left
    @show="buscarObservacoes"
  >
    <template #button-content>
      <feather-icon
        :badge="observacoes.total"
        badge-classes="bg-success"
        class="text-body"
        icon="MessageSquareIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex px-1 py-1">
        <h4 class="notification-title mb-0 mr-auto">
          Observações não lidas
        </h4>
        <b-badge
          pill
          variant="light-primary"
        >
          {{ quantidadeNaoLidas }} observações <!-- não lidas -->
        </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <!-- Account Notification -->
      <b-row
        v-for="observacao in observacoes.itensObservacao"
        :key="observacao.id"
        class="w-100 border-bottom-success"
      >
        <b-col>
          <b-link
            href="#"
            class="d-block font-weight-bolder"
            @click.prevent="abrirObservacao(observacao.titulo)"
          >
            <span class="ml-1 font-weight-bolder">
              {{ observacao.titulo }}
            </span>
            <span class="float-right">{{ observacao.valor }}</span>
          </b-link>
        </b-col>
      </b-row>
    </vue-perfect-scrollbar>
  </b-nav-item-dropdown>
</template>

<script>
/* eslint-disable no-param-reassign */
import { ref, computed } from '@vue/composition-api'
import {
  BNavItemDropdown, BBadge,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import EventBus from '@app/shared/mixins/event-bus/eventBus'
import { useRouter } from '@core/utils/utils'
import api from './services/api'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    VuePerfectScrollbar,
  },
  directives: {
    Ripple,
  },
  setup() {
    const observacoes = ref([])

    const buscarObservacoes = async () => {
      observacoes.value = (await api.getAll()).data
    }

    // const router = useRouter()
    const { router } = useRouter()

    const rotasPorObservacao = {
      'Caixa Postal': 'caixapostal-view',
      'Situação Fiscal': 'situacaofiscal-view',
      'Cnd Estadual': 'cndestadual-view',
      'Cnd FGTS': 'cndfgts-view',
      'Cnd Trabalhista': 'cndtrabalhista-view',
      'Cnd RFB/PGFN': 'cndfederal-view',
      'Cnd Municipal': 'cndmunicipal-view',
      // eslint-disable-next-line quote-props
      'DAS': 'das-view',
      'Parcelamento Simples Nacional': 'dasparcelamento-view',
      'Parcelamento PERT-SN': 'parcelamento_pertsn-view',
      'Parcelamento RELP-SN': 'parcelamento_relpsn-view',
      'Parcelamento RFB': 'parcelamento_rfb-view',
      'Parcelamento Não Previdenciário': 'parcelamento_nao_previdenciario-view',
      'Parcelamento Simplificado Previdenciário': 'parcelamento_simpl_previdenciario-view',
      'Parcelamento PGFN': 'pgfnparcelamento-view',
      'Portal Documentos Downloads': 'portal-documento-view',
      'Portal Documentos CNDs': 'cnd-portal-documento-view',
      // eslint-disable-next-line quote-props
      'Sublimite': 'sublimite-view',
      'Monitoramento 360': 'monitoramento-360-view',
    }

    const abrirObservacao = observacao => {
      const rota = rotasPorObservacao[observacao]

      if (rota) {
        const destino = { name: rota, query: { filtroRapido: 'PossuiObservacao' } }

        if (router.currentRoute.name === rota) {
          router.replace(destino).then(() => {
            window.location.reload()
          })
        } else {
          router.push(destino)
        }
      }
    }

    buscarObservacoes()

    EventBus.$on('atualizaObservacoes', () => buscarObservacoes())

    const perfectScrollbarSettings = {
      wheelPropagation: false,
    }

    const quantidadeNaoLidas = computed(() => observacoes.value.total)

    return {
      quantidadeNaoLidas,
      observacoes,
      buscarObservacoes,
      perfectScrollbarSettings,
      abrirObservacao,
    }
  },
}
</script>

<style>

</style>
